// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonials_testimonialsCards__kwtBL, .testimonials_testimonialProfile__BzIQL {
    margin: 0 auto;
}

.testimonials_testimonialsCards__kwtBL, .testimonials_profileWrapper__zLBrS, .testimonials_testimonialProfile__BzIQL {
    gap: 16px;
}

.testimonials_testimonialsSection__xVOvu {
    align-items: center;
    background-color: #495E57;
}

.testimonials_testimonialsSection__xVOvu > h2 {
    margin-bottom: 20px;
    text-align: center;
}

.testimonials_testimonialsCards__kwtBL {
    flex-direction: column;
    justify-content: space-between;
    width: 50%;
}

.testimonials_profileWrapper__zLBrS {
    align-items: center;
}

.testimonials_testimonialProfile__BzIQL {
    background-color: #FBDABB;
    justify-content: space-between;
    padding: 10px;
    width: 100%;
}

.testimonials_profile__pamIo {
    height: 80px;
    width: 80px;
}

.testimonials_profile__pamIo img {
    border: solid 2px #495E57;
    width: 100%;
}

@media (min-width: 1475px) {
    .testimonials_testimonialsCards__kwtBL {
        flex-direction: row;
        justify-content: unset;
        width:unset;
    }

    .testimonials_testimonialProfile__BzIQL {
        width: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/Testimonials/testimonials.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI;QACI,mBAAmB;QACnB,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".testimonialsCards, .testimonialProfile {\n    margin: 0 auto;\n}\n\n.testimonialsCards, .profileWrapper, .testimonialProfile {\n    gap: 16px;\n}\n\n.testimonialsSection {\n    align-items: center;\n    background-color: #495E57;\n}\n\n.testimonialsSection > h2 {\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.testimonialsCards {\n    flex-direction: column;\n    justify-content: space-between;\n    width: 50%;\n}\n\n.profileWrapper {\n    align-items: center;\n}\n\n.testimonialProfile {\n    background-color: #FBDABB;\n    justify-content: space-between;\n    padding: 10px;\n    width: 100%;\n}\n\n.profile {\n    height: 80px;\n    width: 80px;\n}\n\n.profile img {\n    border: solid 2px #495E57;\n    width: 100%;\n}\n\n@media (min-width: 1475px) {\n    .testimonialsCards {\n        flex-direction: row;\n        justify-content: unset;\n        width:unset;\n    }\n\n    .testimonialProfile {\n        width: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"testimonialsCards": `testimonials_testimonialsCards__kwtBL`,
	"testimonialProfile": `testimonials_testimonialProfile__BzIQL`,
	"profileWrapper": `testimonials_profileWrapper__zLBrS`,
	"testimonialsSection": `testimonials_testimonialsSection__xVOvu`,
	"profile": `testimonials_profile__pamIo`
};
export default ___CSS_LOADER_EXPORT___;
